// extracted by mini-css-extract-plugin
export default {"page":"InstructionDetailPage_page__RVm6o","shareButton":"InstructionDetailPage_shareButton__w4Rm1","pageContainer":"InstructionDetailPage_pageContainer__3ZPKS"};